export default __webpack_public_path__ + "steinberg-nuendo.56917786.png";